import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

import SortField from "@app/component/RecordList/components/CustomizeMapSortModal/enum/SortField";

const messagesAsc = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "recordList.customization.sort.createdAt.asc",
    defaultMessage: "Least recently created",
    description: "Records list customization sort - Least recently created",
  },
  [SortField.GEOPOINT]: {
    id: "recordList.customization.sort.location.asc",
    defaultMessage: "Closest to my current location",
    description: "Deals card filter option - Closest to my current location",
  },
  [SortField.LAST_ACTIVITY_DATE]: {
    id: "recordList.customization.sort.lastCompletedActivity.asc",
    defaultMessage: "Least recently contacted",
    description: "Deals card filter option - Most recently contacted",
  },
  [SortField.NAME]: {
    id: "recordList.customization.sort.name.asc",
    defaultMessage: "A > Z",
    description: "Records list customization sort - A > Z",
  },
  [SortField.NEXT_ACTIVITY]: {
    id: "recordList.customization.sort.upcomingActivity.asc",
    defaultMessage: "Upcoming first",
    description: "Deals card filter option - Upcoming first",
  },
  [SortField.UPDATED_AT]: {
    id: "recordList.customization.sort.updatedAt.asc",
    defaultMessage: "Least recently modified",
    description: "Records list customization sort - Least recently modified",
  },
});

const messagesDesc = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "recordList.customization.sort.createdAt.desc",
    defaultMessage: "Most recently created",
    description: "Records list customization sort - Most recently created",
  },
  [SortField.GEOPOINT]: {
    id: "recordList.customization.sort.location.desc",
    defaultMessage: "Farthest from me",
    description: "Deals card filter option - Farthest from me",
  },
  [SortField.LAST_ACTIVITY_DATE]: {
    id: "recordList.customization.sort.lastCompletedActivity.desc",
    defaultMessage: "Most recently contacted",
    description: "Records list customization sort - Least recently contacted",
  },
  [SortField.NAME]: {
    id: "recordList.customization.sort.name.desc",
    defaultMessage: "Z > A",
    description: "Records list customization sort - Name desc direction",
  },
  [SortField.NEXT_ACTIVITY]: {
    id: "recordList.customization.sort.upcomingActivity.desc",
    defaultMessage: "Most distant first",
    description: "Records list customization sort - Most distant first",
  },
  [SortField.UPDATED_AT]: {
    id: "recordList.customization.sort.updatedAt.desc",
    defaultMessage: "Most recently modified",
    description: "Records list customization sort - Most recently modified",
  },
});

const getSortDirectionNameForField = (
  intl: IntlShape,
  fieldName: SortField,
  order: SortOrder
): string =>
  order === SortOrder.DESC
    ? intl.formatMessage(messagesDesc[fieldName])
    : intl.formatMessage(messagesAsc[fieldName]);

export default getSortDirectionNameForField;
